<template>
  <el-drawer
    :visible.sync="drawerVisible"
    direction="rtl"
    size="60%"
    :before-close="handleClose"
  >
    <div v-if="drawerVisible" style="padding: 20px;">
      <el-tabs v-model="promotionMode" @tab-click="handleTabClick">
        <el-tab-pane label="广告" name="promotion" />
        <el-tab-pane label="项目" name="project" />
      </el-tabs>
      <el-table
        :key="promotionMode"
        v-loading="promotionLoading"
        :data="promotionData.list || []"
        border
        style="width: 100%;margin-top: 20px;"
      >
        <!-- <el-table-column
          prop="account_id"
          label="广告主ID"
          align="center"
          width="120"
        /> -->
        <el-table-column
          v-if="promotionMode == 'project'"
          prop="project_id"
          label="项目ID"
          align="center"
          width="200"
        />
        <el-table-column
          v-if="promotionMode == 'project'"
          prop="project_name"
          label="项目名称"
          align="center"
        />
        <el-table-column
          v-if="promotionMode == 'promotion'"
          prop="promotion_id"
          label="计划ID"
          align="center"
          width="200"
        />
        <el-table-column
          v-if="promotionMode == 'promotion'"
          prop="promotion_name"
          label="计划名称"
          align="center"
        />

        <el-table-column
          prop="is_open"
          label="操作状态"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.is_open"
              :active-value="true"
              :inactive-value="false"
              :disabled="scope.row.is_open == false"
              @change="handleSwitchChange(scope.row)"
            />
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="promotionData.count"
        :page-sizes="[10]"
        @size-change="fetchPromotionPageSize"
        @current-change="fetchPromotionCurrentPage"
      />
    </div>
  </el-drawer>
</template>

<script>
import { promotionsList, closeAd } from '@/api/notify.js'
import PaginationRight from '@/components/PaginationRight/index.vue'

export default {
  name: 'PromotionDrawer',
  components: {
    PaginationRight
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    accountId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      drawerVisible: false,
      promotionMode: 'promotion', // promotion 或 project
      promotionData: {
        list: [],
        count: 0
      },
      promotionLoading: false,
      promotionParameter: {
        page: 1,
        page_size: 10,
        account_id: null,
        mode: 'promotion'
      }
    }
  },
  watch: {
    visible(newVal) {
      this.drawerVisible = newVal
      if (newVal && this.accountId) {
        // 使用 nextTick 确保 accountId 已经更新完成
        this.$nextTick(() => {
          this.promotionParameter.account_id = this.accountId
          this.promotionParameter.mode = this.promotionMode
          this.promotionParameter.page = 1
          this.getPromotionList()
        })
      }
    },
    drawerVisible(newVal) {
      if (!newVal) {
        this.$emit('update:visible', false)
        this.promotionData = {
          list: [],
          count: 0
        }
      }
    },
    accountId(newVal, oldVal) {
      // 只在抽屉已打开且 accountId 真正变化时更新（避免初始化时重复请求）
      if (newVal && this.drawerVisible && oldVal !== null && newVal !== oldVal) {
        this.promotionParameter.account_id = newVal
        this.promotionParameter.page = 1
        this.getPromotionList()
      }
    }
  },
  methods: {
    // 关闭抽屉
    handleClose() {
      this.drawerVisible = false
      this.$emit('update:visible', false)
    },
    // 获取广告状态列表
    async getPromotionList() {
      if (!this.promotionParameter.account_id) {
        return
      }
      this.promotionLoading = true
      try {
        const data = await promotionsList(this.promotionParameter)
        console.log('data11111', data.data)
        this.promotionData = {
          list: data.data?.list || data.data?.data?.list || data.list || [],
          count: data.data?.count || data.data?.data?.count || data.count || 0
        }
      } catch (err) {
        console.error('获取广告状态列表失败:', err)
        this.promotionData = {
          list: [],
          count: 0
        }
      }
      this.promotionLoading = false
    },
    // Tab 切换
    handleTabClick(tab) {
      this.promotionMode = tab.name
      this.promotionParameter.mode = tab.name
      this.promotionParameter.page = 1
      // 先清空数据，避免表格列错乱
      this.promotionData = {
        list: [],
        count: 0
      }
      this.getPromotionList()
    },
    // 广告状态列表分页大小变化
    fetchPromotionPageSize(s) {
      this.promotionParameter.page_size = s
      this.promotionParameter.page = 1
      this.getPromotionList()
    },
    // 广告状态列表当前页变化
    fetchPromotionCurrentPage(s) {
      this.promotionParameter.page = s
      this.getPromotionList()
    },
    // 开关切换
    async handleSwitchChange(row) {
      console.log(row, 'row')
      const data = await closeAd({
        account_id: row.account_id,
        // eslint-disable-next-line eqeqeq
        project_ids: this.promotionMode == 'project' ? [row.project_id] : [],
        // eslint-disable-next-line eqeqeq
        promotion_ids: this.promotionMode == 'promotion' ? [row.promotion_id] : []
      })
      if (data.code === 0) {
        this.$message.success('关闭请求成功，任务已进入请求队列中，请稍等')
        this.getPromotionList()
      } else {
        // this.$message.error('关闭失败')
      }

      console.log(data, 'data')
    }
  }
}
</script>

<style scoped>
</style>

